export default __webpack_public_path__ + "static/media/measurment.b6e3cdb1.jpg";